import { normalizeSeverity } from '../constants/colors';

export function getRiskLevel(severity) {
  const s = normalizeSeverity(severity);
  if (s === 'critical' || s === 'high') return 'high';
  if (s === 'medium') return 'medium';
  if (s === 'low') return 'low';
  return 'unknown';
}

export const RISK_STYLES = {
  high: {
    label: 'HIGH RISK',
    border: 'border-l-[#e11d48]',
    strip: 'bg-[#e11d48]',
    stripBg: 'bg-rose-50/70',
    badge: 'bg-rose-50 text-rose-700 border border-rose-200',
    dot: 'bg-rose-500',
    brief: 'bg-rose-50/40 border-rose-200/60 hover:border-rose-300',
    briefTitle: 'text-slate-900',
    briefText: 'text-slate-600',
    chart: '#e11d48',
  },
  medium: {
    label: 'MEDIUM RISK',
    border: 'border-l-[#d97706]',
    strip: 'bg-[#f59e0b]',
    stripBg: 'bg-amber-50/70',
    badge: 'bg-amber-50 text-amber-800 border border-amber-200',
    dot: 'bg-amber-500',
    brief: 'bg-amber-50/40 border-amber-200/60 hover:border-amber-300',
    briefTitle: 'text-slate-900',
    briefText: 'text-slate-600',
    chart: '#f59e0b',
  },
  low: {
    label: 'LOW RISK',
    border: 'border-l-[#059669]',
    strip: 'bg-[#10b981]',
    stripBg: 'bg-emerald-50/70',
    badge: 'bg-emerald-50 text-emerald-800 border border-emerald-200',
    dot: 'bg-emerald-500',
    brief: 'bg-emerald-50/40 border-emerald-200/60 hover:border-emerald-300',
    briefTitle: 'text-slate-900',
    briefText: 'text-slate-600',
    chart: '#10b981',
  },
  unknown: {
    label: 'UNKNOWN',
    border: 'border-l-slate-300',
    strip: 'bg-slate-300',
    stripBg: 'bg-slate-50',
    badge: 'bg-slate-100 text-slate-600 border border-slate-200',
    dot: 'bg-slate-400',
    brief: 'bg-white border-slate-200/90',
    briefTitle: 'text-slate-900',
    briefText: 'text-slate-600',
    chart: '#94a3b8',
  },
};

export function getRiskStyle(severity) {
  return RISK_STYLES[getRiskLevel(severity)] || RISK_STYLES.unknown;
}